export type UploadDropdownPasteOption = {
  label: string;
  value: string;
  fundName?: string; // used only for tranche rows to allow no firm prefix for matching
};

const normalizePasteKey = (raw: string) =>
  raw.trim().replace(/\s+/g, ' ').toLowerCase();

export const resolveUploadDropdownPasteValue = (
  raw: string,
  values: Array<UploadDropdownPasteOption>,
) => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (values.find((o) => o.value === trimmed)) {
    return trimmed;
  }

  const key = normalizePasteKey(trimmed);
  const byLabel = values.filter((o) => normalizePasteKey(o.label) === key);
  if (byLabel.length === 1) {
    return byLabel[0].value;
  }

  // fall back to try resolution via the tranche name
  const byFundName = values.filter(
    (o) => o.fundName && normalizePasteKey(o.fundName) === key,
  );
  if (byFundName.length === 1) {
    return byFundName[0].value;
  }

  return '';
};
